<template>
    <div class="padding-x" v-if="shouldShowAds">
        <!-- 300*250vowave -->
        <Adsense
                data-ad-test="on"
                data-ad-client="ca-pub-8118624680281970"
                data-ad-slot="7392234444">
        </Adsense>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    
    export default {
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['isAuthenticated', 'isProUser']),
            shouldShowAds() {
                // Don't show ads if user is authenticated and is a pro user
                return !(this.isAuthenticated && this.isProUser);
            }
        },
        mounted() {
        }
    }
</script>
